import { render, staticRenderFns } from "./WithdrawalModalText.vue?vue&type=template&id=6e523319&scoped=true&"
import script from "./WithdrawalModalText.vue?vue&type=script&lang=js&"
export * from "./WithdrawalModalText.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalModalText.vue?vue&type=style&index=0&id=6e523319&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e523319",
  null
  
)

export default component.exports